import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_left",
  "use": "icon-arrow_left-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol viewBox=\"0 0 10 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_left\">\n<path d=\"M8.10547 0.22177L0.993969 7.54777C0.865177 7.67656 0.800781 7.83056 0.800781 8.00977C0.800781 8.18898 0.865177 8.35008 0.993969 8.49308L8.10547 15.8191C8.23426 15.9337 8.38459 15.991 8.55647 15.991C8.72834 15.991 8.87868 15.9266 9.00747 15.7978C9.13626 15.669 9.20066 15.5186 9.20066 15.3468C9.20066 15.1749 9.13626 15.0246 9.00747 14.8958L2.30434 8.02077L9.00747 1.14577C9.13626 1.01698 9.20066 0.866645 9.20066 0.69477C9.20066 0.522895 9.13626 0.372562 9.00747 0.24377C8.87868 0.114979 8.72834 0.0505829 8.55647 0.0505829C8.38459 0.0505829 8.23426 0.107875 8.10547 0.222458V0.22177Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow_left.svg
// module id = sZGS
// module chunks = 258